<template>
  <div class="table-container mx-1" v-if="canVerb(resource, 'index')">
    <!-- <div v-if="!isLoading"> -->
    <actions-toolbar>
      <template #filters>
        <div class="status-filter">
          <div class="pill-wrapper my-3">
            <span
              class="pill"
              v-for="(value, name, index) in activeFilters"
              :key="index"
              data-color="white"
            >
              <span v-b-toggle.sidebar-1 :data-filter="name"
                ><strong>{{ sidebarFilterName(name) }}</strong
                >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
              >
              <span tabindex="0">
                <span
                  @click="resetSingleSidebarFilter(name)"
                  title="Rimuovi filtro"
                  >×</span
                >
              </span>
            </span>
            <template v-if="countActiveFilters">
              <span
                class="pill"
                data-color="alert"
                @click="resetAllFilters()"
                title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
              >
                <span
                  ><strong>Reset ({{ countActiveFilters }})</strong></span
                >
                <span><span>×</span></span>
              </span>
            </template>
          </div>
        </div>
      </template>
      <b-button-group
        v-b-toggle.sidebar-1
        :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
          countActiveFilters ? ' active' : ''
        }`"
        :title="getDefaultFilterMessage()"
      >
        <base-icon name="filters" width="23" height="23" />
        <span style="font-size: 14px; font-weight: 500">{{
          computedFilterTitle
        }}</span>
      </b-button-group>
      <b-button
        :id="`popover-create`"
        class="btn-create btn--smaller"
        type="button"
        variant="primary"
        size="sm"
        @click="onAdd"
        title="Crea un nuovo flusso"
        v-if="canVerb(resource, 'store')"
      >
        <base-icon name="circled_plus" width="22" height="22" />
        Crea
      </b-button>
    </actions-toolbar>
    <div class="table-container">
      <b-sidebar
        id="sidebar-1"
        :title="computedFilterTitle"
        :backdrop="true"
        width="50dvw"
        shadow
        right
        :visible="open_filter"
        :data-open="open_filter"
        @change="onSidebarFilterChange"
      >
        <template #header="{ hide }">
          <div class="inner-header">
            <template v-if="canVerb(resource, 'store')">
              <div class="inner-header--create">
                <strong class="mr-auto"> Crea un nuovo flusso </strong>
                <b-button
                  class="btn btn--create btn--smaller"
                  type="button"
                  variant="primary"
                  size="sm"
                  @click="onAdd"
                  title="Crea un nuovo flusso"
                  :disabled="!canVerb(resource, 'store')"
                >
                  <base-icon name="circled_plus" width="16" height="16" />
                  <span>Crea</span>
                </b-button>
              </div>
              <div class="inner-header--info">
                <strong class="mr-auto">
                  {{ computedFilterTitle }}
                </strong>
                <button class="close text-dark" @click="hide">
                  <b-icon icon="x"></b-icon>
                </button>
              </div>
            </template>
            <template v-else>
              <strong class="mr-auto">
                {{ computedFilterTitle }}
              </strong>
              <button class="close text-dark" @click="hide">
                <b-icon icon="x"></b-icon>
              </button>
            </template>
          </div>
        </template>
        <b-form @submit.prevent="onSearch(filterName)">
          <div class="filter">
            <div class="filter-item">
              <base-select
                name="bank"
                label="Banca"
                :options="bank_accounts"
                v-model="filter.byBankAccount.id"
              />
            </div>
            <div class="filter-item">
              <!-- <base-datepicker
                name="setup_at"
                label="Data istanziamento SDD"
                v-model="filter.byAttribute.setup_at"
              ></base-datepicker> -->
              <base-month-picker
                name="setup_at"
                label="Data istanziamento SDD"
                v-model="filter.byAttribute.setup_at"
              />
            </div>
          </div>
          <div class="actions-filter-sidebar-wrapper">
            <b-button
              type="submit"
              variant="lisaweb"
              size="sm"
              v-b-toggle:sidebar-1
              >Cerca
            </b-button>
            <b-button
              class="btn--transparent btn-reset"
              type="button"
              size="sm"
              @click="onClearFilter(filterName)"
              >Reset
            </b-button>
          </div>
        </b-form>
      </b-sidebar>
      <direct-debits-table
        @edit="onEdit"
        @manualFetch="manualFetch"
        :performedSearch="computePerformedSearch"
        :filterCount="countActiveFilters"
        @download="downloadXml"
        :fields="fields"
        :repository="repository"
        :resource="resource"
        :filterName="filterName"
        :filterOn="{
          byRelations: ['byBankAccount', 'byPaymentProcedure'],
        }"
        @destroy="onDestroy"
        :ref="tableRef"
        :onlyActions="['edit', 'destroy']"
      ></direct-debits-table>
    </div>

    <div>
      <multi-select-option-modal
        title="
        Creazione nuovo flusso"
        description=""
        @create="create"
      />
    </div>
    <!-- </div> -->
    <!-- <template #overlay>
      <div class="text-center mt-5">
        <base-icon name="loading" width="35" height="35" />
        <p id="cancel-label">Operazione in corso...</p>
      </div>
    </template> -->
  </div>
  <div v-else class="mt-3">
    <b-icon icon="info-circle" scale="1.00"></b-icon>
    Non hai i permessi
  </div>
</template>

<script>
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import DirectDebitsTable from "@/components/tables/DirectDebits.vue";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import FormMixin from "@/mixins/FormMixin";
import BaseSelect from "@/components/form/BaseSelect";
import BaseMonthPicker from "@/components/form/BaseMonthPicker";
import MultiSelectOptionModal from "@/components/modals/multiSelectOption";
import { mapGetters, mapActions } from "vuex";
import { toLocaleDate } from "@/utils/dates";
import moment from "moment";
import BaseIcon from "@/components/BaseIcon";
import SidebarFilterMixin from "../../../mixins/SidebarFilterMixin";

moment.locale("it");

export default {
  mixins: [CustomFiltersMixin, DocumentsMixin, FormMixin, SidebarFilterMixin],
  data() {
    return {
      // companies: [],
      isLoading: false,
      bank_accounts: [],
      repository: "direct_debit",
      resource: "direct_debits",
      tableRef: "DirectDebitsTableRef",
      filterName: "filterDirectDebits",
      activeFilters: {},
      performedSearch: false,
      filter: this.initFilter(),
      fields: [
        {
          key: "id",
          label: this.getDictionary("id", "direct_debit"),
        },
        {
          key: "bank_account.formatted_title",
          label: this.getDictionary("bank_account_id", "direct_debit"),
        },
        {
          key: "setup_at",
          formatter: (value) => toLocaleDate(value, "MM/YYYY"),
          label: this.getDictionary("setup_at", "direct_debit"),
        },
        {
          key: "payment_procedure_count",
          // label: this.getDictionary("payment_procedure_count", "direct_debit"),
          label: "Quietanze nel flusso in partenza / escluse / totali",
        },
        {
          key: "download_xml",
          label: this.getDictionary("download_xml", "direct_debit"),
        },
      ],
      setupAtMoment: {},
      // selects: [
      //   {
      //     title: "Banca",
      //     options: [
      //       { text: "Banca 1", value: 1 },
      //       { text: "Banca 2", value: 2 },
      //     ],
      //     required: true,
      //   },
      //   {
      //     title: "Compagnia",
      //     options: this.companies,
      //     required: false,
      //   },
      // ],
    };
  },
  components: {
    BaseIcon,
    DirectDebitsTable,
    BaseSelect,
    // BaseDatepicker,
    BaseMonthPicker,
    MultiSelectOptionModal,
  },
  computed: {
    countActiveFilters() {
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
    computePerformedSearch() {
      return this.performedSearch;
    },
  },
  methods: {
    toLocaleDate,
    downloadXml(item) {
      item.title = `SEPA_${item.id}_${moment(item.setup_at).format(
        "YYYYMM",
      )}_${moment().format("YYYYMMDDHHmmss")}`;
      item.extension = "xml";
      this.downloadDocumentSepa(item, "payment_procedure");
    },
    create(form) {
      this.$refs[this.tableRef].isLoading = true;
      this.store(this.repository, form)
        .then(() => {
          this.$refs[this.tableRef].fetch();
          this.$showSnackbar({
            preset: "success",
            text: "Flusso creato correttamente",
          });
          // let procedure_id = response.data.data.id;
          // this.onEdit(procedure_id, response.data.data);
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        })
        .finally(() => {
          this.$refs[this.tableRef].isLoading = false;
        });
    },
    initFilter() {
      let init = {
        byAttribute: {
          setup_at: null,
        },
        byBankAccount: {
          id: null,
        },
      };
      return init;
    },
    customFilterName(key, prefix = "byAttribute") {
      return `${prefix}.${key}`;
    },
    onEdit(id) {
      this.$router.push({
        name: `${this.resource}.edit`,
        params: { id: `${id}` },
      });
    },
    onAdd() {
      this.$bvModal.show("selectOption");
      //this.$router.push({ name: `${this.resource}.create` });
    },
    onSelectOption(val) {
      console.debug("onSelectOption: ", val);
      if (val != null) {
        // const Repo = RepositoryFactory.get(this.repository);
        this.isLoading = true;
        this.fetchCreateForm(this.repository).then(() => {
          // this.form[this.repository].communication_type = val;
          // this.form[this.repository].status_procedure = 1;
          // this.form[this.repository].is_vehicle_premium_shown = 1;
          // this.form[this.repository].is_life_premium_shown = 1;
          // this.form[this.repository].is_extra_vehicle_premium_shown = 1;

          console.log(this.form[this.repository]);
          this.store(this.repository)
            .then((response) => {
              this.isLoading = false;
              this.$showSnackbar({
                preset: "success",
                text: "Flusso creato correttamente",
              });
              let procedure_id = response.data.data.id;
              this.onEdit(procedure_id, response.data.data);
            })
            .catch((error) => {
              let errMsg = this.$getErrorMessage(error);
              this.$showSnackbar({
                preset: "error",
                text: `${errMsg}`,
              });
              this.isLoading = false;
            });
        });
        // this.showConfirm({
        //   yesCallback: () => {
        //     this.saveSelected();
        //   },
        //   // noCallback: () => {
        //   //   this.$bvModal.hide("createInsurancePaymentOptionsModal");
        //   // },
        //   noCallback: null,
        //   title: "Conferma",
        //   message: "Procedere con l'incasso?",
        //   yesLabel: "PROCEDI",
        //   yesVariant: "outline-lisaweb",
        //   noLabel: "ANNULLA",
        //   // yesVariant:
        //   // noVariant:
        //   // headerBgVariant:
        // });
      } else {
        this.$showSnackbar({
          preset: "info",
          text: "Selezionare il tipo",
        });
      }
    },
    onDestroy(id) {
      this.$refs[this.tableRef].isLoading = true;
      const Repo = RepositoryFactory.get(this.repository);
      Repo.destroy(id)
        .then(() => {
          this.$refs[this.tableRef].fetch();
          this.$showSnackbar({
            preset: "success",
            text: "Flusso eliminato con successo",
          });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        })
        .finally(() => {
          this.$refs[this.tableRef].isLoading = false;
        });
    },
    manualFetch() {
      this.resetAllFilters();
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }

      Object.keys(this.activeFilters).forEach((key) => {
        if (key !== "byAttribute.setup_at._i" && key !== "byBankAccount.id") {
          delete this.activeFilters[key];
        }
      });

      return this.activeFilters;
    },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      if (
        typeof this.filter?.byAttribute?.setup_at !== "undefined" &&
        this.filter?.byAttribute?.setup_at !== null
      ) {
        const setup_at_moment = moment(this.filter.byAttribute.setup_at).format(
          "YYYY-MM",
        );
        this.setupAtMoment = this.filter.byAttribute.setup_at;
        this.filter.byAttribute.setup_at = setup_at_moment;
      }
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;
      this.$refs[this.tableRef].fetch().then(() => {
        if (Object.keys(this.setupAtMoment).length)
          this.filter.byAttribute.setup_at = this.setupAtMoment;
      });
    },
    onClearFilter(name) {
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "";
      this.$refs[this.tableRef].sortDesc = false;
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    ...mapGetters("auth", {
      // getInsurers: "insurers",
      getBankAccounts: "bank_accounts",
    }),
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
  },
  created() {
    this.bank_accounts = this.getBankAccounts();
    // this.companies = this.getInsurers();
  },
};
</script>
